// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68693753","991":"0b4c351c"}[chunkId] + ".chunk.js";
};